import { gql } from "@apollo/client";

export const CREATE_LISTING = gql`
  mutation creat($data: CreateListingInput) {
    Listing {
      create(data: $data) {
        id
      }
    }
  }
`;
export const REGISTER_AD_FROM_REGA = gql`
  mutation registerAdFromRega($data: RegaListingNhcApiParamsInput!) {
    RegaListing {
      registerAdFromRega(data: $data) {
        id
        advertiser_id
        ad_license_number
        deed_number
        advertiser_name
        phone_number
        brokerage_and_marketing_license_number
        is_constrained
        is_pawned
        street_width
        property_area
        property_price
        number_of_rooms
        property_type
        property_age
        advertisement_type
        location
        location_region
        location_region_code
        location_city
        location_city_code
        location_district
        location_district_code
        location_street
        location_postal_code
        location_building_number
        location_additional_number
        location_longitude
        location_latitude
        property_face
        plan_number
        obligations_on_the_property
        guarantees_and_their_duration
        the_borders_and_lengths_of_the_property
        compliance_with_the_saudi_building_code
        channels_list
        property_usages_list
        property_utilities_list
        creation_date
        end_date
        qr_code_url
        is_latest_data
        registerer_user_id
      }
    }
  }
`;

export const LOG_SPACE_ACTION = gql`
  mutation logSpaceAction($id: Int!, $action: String!, $text: String) {
    Listing {
      logListingSpaceFeesActions(listing_id: $id, action: $action, text: $text)
    }
  }
`;

export const FOLLOW_SIMILAR_LISTINGS = gql`
  mutation followSimilarListings($listingId: Int!) {
    User {
      followSimilarListings(listing_id: $listingId)
    }
  }
`;
export const UNFOLLOW_SIMILAR_LISTINGS = gql`
  mutation unFollowSimilarListings($listingId: Int!) {
    User {
      unfollowSimilarListings(listing_id: $listingId)
    }
  }
`;

export const CREATE_LISTING_FROM_NHC = gql`
  mutation createListingFromNhc(
    $data: CreateListingInput
    $nhc_input: RegaListingNhcApiParamsInput!
  ) {
    Listing {
      createFromNhc(data: $data, nhc_input: $nhc_input) {
        id
        category
      }
    }
  }
`;

export const REFRESH_LISTING = gql`
  mutation refresh($id: Int!) {
    Listing {
      refresh(id: $id) {
        refresh
      }
    }
  }
`;

export const GET_LISTING_COMMISSION = gql`
  query getListingCommission($id: Int!) {
    Listing {
      getFullDetails(id: $id) {
        aqar_commission
      }
    }
  }
`;
export const UPDATE_LISTING = gql`
  mutation update($id: Int!, $data: UpdateListingInput) {
    Listing {
      update(id: $id, data: $data) {
        id
      }
    }
  }
`;
export const ADD_MOT_LICENSE = gql`
  mutation addMotLicenseNumber(
    $listing_id: Int!
    $mot_license_number: String!
    $owner_id: String!
  ) {
    Listing {
      addMotLicenseNumber(
        listing_id: $listing_id
        mot_license_number: $mot_license_number
        owner_id: $owner_id
      )
    }
  }
`;
export const VERIFY_IDENTITY_BY_OWNER_OTP = gql`
  mutation verifyIdentityByOwnerOtp($owner_otp: String!, $otp: String!) {
    User {
      verifyIdentityByOwnerOtp(owner_otp: $owner_otp, otp: $otp)
    }
  }
`;

export const ADD_DELEGATION = gql`
  mutation addDelegation(
    $listing_id: Int!
    $delegation_id: String
    $delegation_img: String
  ) {
    Listing {
      addDelegation(
        listing_id: $listing_id
        delegation_id: $delegation_id
        delegation_img: $delegation_img
      ) {
        id
      }
    }
  }
`;

export const LISTING_VERIFICATION_DEED_BY_OTP = gql`
  mutation putListingVerificationDeedByOtp(
    $owner_otp: String!
    $filename: String!
  ) {
    User {
      putListingVerificationDeedByOtp(
        owner_otp: $owner_otp
        filename: $filename
      )
    }
  }
`;

export const PAY_BY_ANOTHER_USER = gql`
  mutation payByAnotherUser(
    $listing_id: Int!
    $phone: String!
    $deal_price: Float!
  ) {
    LicensingRequests {
      generateAndSendCommissionPaymentFeesLink(
        listing_id: $listing_id
        phone: $phone
        deal_price: $deal_price
      )
    }
  }
`;
export const VERIFY_LISTING_BY_OWNER_OTP = gql`
  mutation verifyListingByOtp(
    $owner_otp: String!
    $deed_code: Float!
    $deed_img: String!
    $owner_id: Float!
    $owner_id_img: String
    $id_type: DeedIdTypes
  ) {
    Listing {
      verifyListingByOtp(
        owner_otp: $owner_otp
        deed_code: $deed_code
        deed_img: $deed_img
        owner_id: $owner_id
        owner_id_img: $owner_id_img
        id_type: $id_type
      )
    }
  }
`;

export const REPLICATE_NHC_LISTING = gql`
  mutation replicateNhcListing(
    $listing_id: Int!
    $nhc_input: RegaListingNhcApiParamsInput!
  ) {
    Listing {
      replicateNhcListing(listing_id: $listing_id, nhc_input: $nhc_input) {
        id
      }
    }
  }
`;

export const CREATE_RIZE_RNPL_REQUEST = gql`
  mutation createRizeRnplRequest($listing_id: Int!) {
    RentNowPayLater {
      createRizeRnplRequest(listing_id: $listing_id) {
        id
        rize_link
        request_id
        request_date
      }
    }
  }
`;

export const CREATE_HARAJ_RIZE_RNPL_REQUEST = gql`
  mutation createHarajRizeRnplRequest($ad_license_number: String!) {
    RentNowPayLater {
      createHarajRizeRnplRequest(ad_license_number: $ad_license_number) {
        id
        rize_link
        request_id
        request_date
      }
    }
  }
`;

export const CREATE_EJARI_RNPL_REQUEST = gql`
  mutation createEjariRnplRequest(
    $listing_id: Int!
    $id_number: String!
    $date_of_birth: String!
  ) {
    RentNowPayLater {
      createEjariRnplRequest(
        listing_id: $listing_id
        id_number: $id_number
        date_of_birth: $date_of_birth
      ) {
        id
        request_number
        rental_amount
        monthly_payment
        max_monthly_payment
        timestamp
      }
    }
  }
`;

export const CREATE_HARAJ_EJARI_RNPL_REQUEST = gql`
  mutation createHarajEjariRnplRequest(
    $ad_license_number: String!
    $id_number: String!
    $date_of_birth: String!
  ) {
    RentNowPayLater {
      createHarajEjariRnplRequest(
        ad_license_number: $ad_license_number
        id_number: $id_number
        date_of_birth: $date_of_birth
      ) {
        id
        request_number
        rental_amount
        monthly_payment
        max_monthly_payment
        timestamp
      }
    }
  }
`;

export const PAUSE_LISTING = gql`
  mutation pauseListing($id: Int!) {
    Listing {
      pause(listing_id: $id)
    }
  }
`;

export const RESUME_LISTING = gql`
  mutation resumeListing($id: Int!) {
    Listing {
      resume(listing_id: $id)
    }
  }
`;

export const UPDATE_REGA_LISTING_PRICES = gql`
  mutation updateRegaListingDiscount(
    $listing_id: Int!
    $total_price: Float
    $meter_price: Float
  ) {
    Listing {
      updateRegaListingPrices(
        listing_id: $listing_id
        total_price: $total_price
        meter_price: $meter_price
      )
    }
  }
`;

export const ISSUE_BROKER_AD_LICENSE = gql`
  mutation issueBrokerAdLicense($data: IssueBrokerAdLicenseInput!) {
    RegaListing {
      issueBrokerAdLicense(data: $data) {
        ad_license_number
        advertiser_id
      }
    }
  }
`;

export const MARK_LISTING_CONTACT_REQUEST = gql`
  mutation markListingContactRequest(
    $listing_id: Int!
    $listing_contact_request_id: Int!
    $action: ListingContactRequestAction!
  ) {
    Listing {
      markListingContactRequest(
        listing_id: $listing_id
        listing_contact_request_id: $listing_contact_request_id
        action: $action
      )
    }
  }
`;
